import { render, staticRenderFns } from "./lrCreatetime.vue?vue&type=template&id=3247fd1c"
import script from "./lrCreatetime.vue?vue&type=script&lang=js"
export * from "./lrCreatetime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports